import { z } from "zod";

const BREAKER_MAX_REPETITION_PATTERN = /^(?:[1-9]\d*|(?=.*\{[^{}]+\})(?:\d+|\{[^{}]+\})+)$/;

export const breakerFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    maxRepetition: z
        .string()
        .trim()
        .min(1, "components.connection-creator.nodes.breaker.forms.max_repetition_required")
        .refine((value) => BREAKER_MAX_REPETITION_PATTERN.test(value), {
            message: "components.connection-creator.nodes.breaker.forms.max_repetition_invalid",
        }),
});

export type BreakerFormData = z.infer<typeof breakerFormSchema>;
